/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * Content management API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TagDefinition
 */
export interface TagDefinition {
    /**
     * Human-readable tag id (lowercase)
     * @type {string}
     * @memberof TagDefinition
     */
    id: string;
    /**
     * Technical tag identifier (MongoDB ObjectId)
     * @type {string}
     * @memberof TagDefinition
     */
    identifier: string;
    /**
     * Preferred translation of the tag for the request locale
     * @type {string}
     * @memberof TagDefinition
     */
    name: string;
    /**
     * Alternate translations for the tag in the request locale
     * @type {Array<string>}
     * @memberof TagDefinition
     */
    alternateNames?: Array<string>;
}

/**
 * Check if a given object implements the TagDefinition interface.
 */
export function instanceOfTagDefinition(value: object): value is TagDefinition {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('identifier' in value) || value['identifier'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function TagDefinitionFromJSON(json: any): TagDefinition {
    return TagDefinitionFromJSONTyped(json, false);
}

export function TagDefinitionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TagDefinition {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'identifier': json['identifier'],
        'name': json['name'],
        'alternateNames': json['alternateNames'] == null ? undefined : json['alternateNames'],
    };
}

export function TagDefinitionToJSON(value?: TagDefinition | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'identifier': value['identifier'],
        'name': value['name'],
        'alternateNames': value['alternateNames'],
    };
}

